import {useState} from "react";
import Slider from "react-slider";
import "./priceSlider.css";

const MIN = 1000;
const MAX = 20000;
const STEP = 1000;

const PriceSlider = ({handlePriceChange}) => {
    const [values, setValues] = useState([MIN, MAX]);
    // メモリ価格を計算する関数
    const calculateMemoryPrice = (value) => {
        const memoryPrice = Math.floor((value - MIN) / STEP) * STEP + MIN;
        return memoryPrice;
    };

    const renderValues = () => {
        if (values[0] === MAX) {
            return `上限なし`;
        } else {
            return `${calculateMemoryPrice(values[0])} - ${calculateMemoryPrice(
                values[1]
            )}`;
        }
    };

    return (
        <div className="price__slider">
            <div className={"values"}>${renderValues()}</div>
            <Slider
                className={"slider"}
                onChange={(newValues) => {
                    setValues(newValues);
                    handlePriceChange(newValues);
                }}
                value={values}
                min={MIN}
                max={MAX}
                step={STEP}

            />
        </div>
    );
};

export default PriceSlider;
